import React, { PropsWithChildren, useContext, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { observer } from 'mobx-react';
import { InjectorContext } from '~/common/injector.provider';
import { GlobalMXContextValue } from '~/providers/mx-global-context/global-mx.context';
import { getGlobalMXContext } from '~/providers/mx-global-context/global-mx-context.factory';
import { ensureGlobalMXContextInit } from '~/providers/mx-global-context/global-mx-context.utils';
import { GlobalContextProvider } from '~/providers/global.provider';

type Props = {
    skipWaitForInjector?: boolean;
};

export const GlobalMXContextProvider = observer(
    ({ children, skipWaitForInjector }: PropsWithChildren<Props>) => {
        const injector = useContext(InjectorContext);
        const globalContext = getGlobalMXContext();
        const { injectorService } = globalContext;

        useEffect(() => {
            if (injectorService.injector) {
                return;
            }

            injectorService.setInjector(injector);
        }, [injector, injectorService]);

        ensureGlobalMXContextInit(globalContext);

        if (!injectorService.injector && !skipWaitForInjector) {
            return <Skeleton />;
        }

        return (
            <GlobalContextProvider<GlobalMXContextValue> global={globalContext}>
                {children}
            </GlobalContextProvider>
        );
    }
);
